import React, {useMemo, useState} from 'react';
import {Button, Divider, IconButton} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import {DataViewerLabel} from '../../DataViewer/DataViewerLabel';
import {FormattedMessage, useIntl} from 'react-intl';
// import {VIEW_TYPE} from '../const';
import {useStudioDatasetViewerContext} from '../../../base-components/StudioDataset/StudioDatasetViewerProvider';
import {RootState, useAppDispatch} from '../../../store';
import {useSelector} from 'react-redux';
import {deleteDatasetMetadata, getDataset} from '../../../store/dataService';
import {SelectButtonLabel} from '../../../base-components/StudioDataset/FileViewer/SelectButton';
import {difference} from 'lodash';
import {StudioSearch} from '../../../base-components/StudioSearch';
import {dataPrepareActions} from '../../../store/dataPrepare';
import {ItemType, ViewId} from '../../../base-components/StudioDataset/FileViewer';

export const Header = ({
  // view,
  search,
  dataContainerImagesQuantity,
  // onView = () => {},
  onSearch = () => {},
}: {
  search?: string;
  view: ViewId;
  dataContainerImagesQuantity?: number;

  onView?(val: ViewId): void;
  onUpload?(files: File[]): void;
  onSearch?: (val: string) => void;
}) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const {setOpenUploadDialog} = dataPrepareActions;
  const dataset = useSelector((state: RootState) => state.dataset.data);
  const openUploadDialog = useSelector(
    (state: RootState) => state.dataPrepare.openUploadDialog
  );
  const [refreshOnUpload, setRefreshOnUpload] = useState<boolean>(false);

  const {
    selections,
    setSelections,
    binaries: data,
    refreshBinaries,
  } = useStudioDatasetViewerContext();
  const hasVideoAndImage = data?.hasVideoAndImage;
  const items = data?.list || [];

  const selectionIndeterminate =
    !!selections.length && items.length !== selections.length;

  // TODO: enable after fix list view - Alfredo has some progress and context
  // const onViewClick = () => {
  //   const nextView =
  //     view !== VIEW_TYPE.LIST
  //       ? VIEW_TYPE.LIST
  //       : hasVideoAndImage
  //       ? VIEW_TYPE.LABEL
  //       : VIEW_TYPE.LABEL;
  //   onView(nextView);
  // };

  const onDelete = async () => {
    if (selections.length && dataset) {
      await dispatch(
        deleteDatasetMetadata({
          datasetId: dataset.id,
          metadataIds: selections.join(),
        })
      );
      setSelections([]);
      refreshBinaries();
      dispatch(getDataset({datasetId: dataset.id, version: dataset.version}));
    }
  };

  const onListSelectAll = (toggle: boolean, ids: string[] = []) => {
    if (ids.length) {
      setSelections(toggle ? selections.concat(ids) : difference(selections, ids));
    } else {
      setSelections(toggle ? items.map((el: ItemType) => el.id) : []);
    }
  };

  useMemo(() => openUploadDialog && setRefreshOnUpload(true), [openUploadDialog]);
  useMemo(() => {
    if (!openUploadDialog && refreshOnUpload) {
      refreshBinaries();
      setRefreshOnUpload(false);
    }
  }, [openUploadDialog, refreshBinaries, refreshOnUpload]);

  const binaryTotal = useMemo(
    () =>
      (data?.group.reduce((counter, group) => counter + group.totalElements, 0) ?? 0) +
      (dataContainerImagesQuantity ?? 0),
    [data, dataContainerImagesQuantity]
  );

  return (
    <div className="data-review__menu">
      {!hasVideoAndImage ? (
        <DataViewerLabel
          className="data-review__label"
          label={intl.formatMessage({id: 'dataPrep.review.total.images'})}
          count={binaryTotal || 0}
        />
      ) : (
        <div />
      )}
      <div />
      <StudioSearch
        autoFocus
        size="small"
        placeholder={intl.formatMessage({id: 'form.search'})}
        onChange={e => onSearch(e.target.value)}
        value={search}
      />
      <Divider orientation="vertical" flexItem />
      <SelectButtonLabel
        label={intl.formatMessage({
          id: `dataPrep.review.${
            items.length > 0 &&
            selections.length > 0 &&
            items.length === selections.length
              ? 'deselectAll'
              : 'selectAll'
          }`,
        })}
        checked={items.length > 0 && selections.length === items.length}
        indeterminate={selectionIndeterminate}
        onChange={(e, val) => onListSelectAll(val)}
        nativeTooltip={
          items.length ? null : intl.formatMessage({id: 'fileViewer.noFilesToSelect'})
        }
      />
      <Divider orientation="vertical" flexItem />
      {/* TODO: enable after fix list view - Alfredo has some progress and context
       <IconButton size="medium" onClick={onViewClick}>
        {view !== VIEW_TYPE.LIST ? <ListIcon /> : <GridIcon />}
      </IconButton> */}

      <IconButton
        size="medium"
        onClick={onDelete}
        color="secondary"
        disabled={!selections.length}
      >
        <DeleteIcon />
      </IconButton>
      <Divider orientation="vertical" flexItem />
      <Button
        color="primary"
        onClick={() => dispatch(setOpenUploadDialog(true))}
        size="large"
      >
        <FormattedMessage id="dataPrep.review.add" />
      </Button>
    </div>
  );
};
